import { render, staticRenderFns } from "./GiftAddToCart.vue?vue&type=template&id=3e0421ee"
import script from "./GiftAddToCart.vue?vue&type=script&lang=js"
export * from "./GiftAddToCart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports